// EsTreatmentCard.jsx
import React, { useContext } from "react";
import { Col } from "react-bootstrap";
import AppContext from "../../../context/AppContext";
import { useNavigate } from "react-router-dom";

const truncateText = (text, maxLength = 90) => {
  if (!text) return "";
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength).trim() + "...";
};

const EsTreatmentCard = ({ treatment, screenName }) => {
  const {
    setSelectedTreatmentFromLandingPage,
    baseUrlForFile,
  } = useContext(AppContext);

  const navigate = useNavigate();

  if (!treatment) {
    return null;
  }

  return (
    <Col lg={4} md={6} sm={12} className="mb-4">
      <div className="estatica-cards__img-wrapper">
        <img
          src={`${baseUrlForFile}/${treatment.image}`}
          alt={treatment.name}
        />
      </div>

      <h4 className="estatica-cards__name">{treatment.name}</h4>

      <p className="estatica-cards__meta">
        {treatment.duration} &nbsp;•&nbsp; {treatment.price}
      </p>

      <p className="estatica-cards__desc">
        {truncateText(treatment.description)}
      </p>

      {screenName === "customer" && (
        <button
          className="estatica-cards__btn"
          onClick={() => {
            setSelectedTreatmentFromLandingPage(treatment);
            navigate("/treatment-details");
          }}
        >
          View details
        </button>
      )}
    </Col>
  );
};

export default EsTreatmentCard;